import React from "react";
import PropTypes from "prop-types";
import * as styles from "./CommonLoader.module.scss";
import { LoadingSpinner } from "cprime-foundational-components";
const scssClass = styles as any;

type CommonLoaderProps = Readonly<{
  active: boolean;
}>;

export default function CommonLoader({ active }: CommonLoaderProps) {
  return (
    <div
      className={`${scssClass.commonLoaderContainer} ${
        active ? scssClass.block : scssClass.hidden
      }`}
    >
      <LoadingSpinner fullScreen />
    </div>
  );
}

CommonLoader.propTypes = {
  active: PropTypes.bool.isRequired,
};
